import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'delete-confirmation-dialog',
  templateUrl: './delete-confirmation-dialog.component.html',
  styleUrls: ['./delete-confirmation-dialog.component.scss']
})
export class DeleteConfirmationDialogComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<DeleteConfirmationDialogComponent>) { }

  ngOnInit() {
  }

  onCloseClick() {
      this.dialogRef.close({ data: { goAhead: false } });
  }

  onConfirmDeleteClick() {
      this.dialogRef.close({ data: { goAhead: true } });
  }
}
